import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { StoryblokImageDescriptionComponent } from '../../app/content/modules/storyblok/components/storyblok-image-description/storyblok-image-description.component';
import { withStoryblokDecorators } from '../_utils/story-helpers';

const meta: Meta<StoryblokImageDescriptionComponent> = {
  title: 'Storyblok/Image Description',
  component: StoryblokImageDescriptionComponent,
  decorators: [...withStoryblokDecorators()],
  parameters: {
    docs: {
      description: {
        component: 'Storyblok image with description block. Renders an image with title, description text, and optional icon.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<StoryblokImageDescriptionComponent>;

export const Default: Story = {
  args: {
    image: { filename: 'https://a.storyblok.com/f/106593/5459x1241/65f115b636/supervin_hvidorange_highres.png', alt: 'Vineyard' },
    title: 'Château Margaux',
    description: '<p>En af de mest prestigefyldte vingårde i Bordeaux, kendt for deres elegante og komplekse vine.</p>',
    _uid: 'sb-img-desc-1',
    component: 'image_description',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-image-description')).toBeTruthy();
  },
};

export const WithIcon: Story = {
  args: {
    image: { filename: 'https://a.storyblok.com/f/106593/100x100/f35c5f3002/gron-drue-tegning.jpg', alt: 'Organic vineyard' },
    title: 'Økologisk vinproduktion',
    description: '<p>Vi fokuserer på bæredygtige dyrkningsmetoder uden brug af pesticider.</p>',
    icon: { filename: 'https://a.storyblok.com/f/106593/100x100/cc535ac665/bla-drue-tegning.jpg' },
    _uid: 'sb-img-desc-2',
    component: 'image_description',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-image-description')).toBeTruthy();
  },
};

export const WithBackgroundColor: Story = {
  args: {
    image: { filename: 'https://a.storyblok.com/f/106593/100x100/5f307117b7/begge-druer-tegning.jpg', alt: '' },
    title: 'Nyheder',
    description: '<p>Se vores nyeste tilføjelser til sortimentet.</p>',
    background_color: '#f5f5f5',
    _uid: 'sb-img-desc-3',
    component: 'image_description',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-image-description')).toBeTruthy();
  },
};

export const NoImage: Story = {
  args: {
    title: 'Kun tekst',
    description: '<p>Denne sektion har ingen billede, kun tekst og titel.</p>',
    _uid: 'sb-img-desc-4',
    component: 'image_description',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-image-description')).toBeTruthy();
  },
};
